import axios from "axios";

export const APIHelper = {
    postDataCustomer: async function (body, bearerToken) {
        const configs = {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                "Access-Controller-Allow-Headers": "Content-Type",
                "Access-Control-Allow-Methods": "PUT, POST, PATCH, DELETE, GET",
                "Authorization": `Bearer ${bearerToken}`
            }
        }
        return await axios.post(process.env.REACT_APP_API_GW, body, configs).then(result => result.data).catch(err => err.response.status);
    },
    getDataPdf: async function (body, bearerToken) {
        const configs = {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/pdf",
                "Access-Controller-Allow-Headers": "Content-Type",
                "Access-Control-Allow-Methods": "PUT, POST, PATCH, DELETE, GET",
                "Authorization": `Bearer ${bearerToken}`
            }
        }
        return await axios.get(process.env.REACT_APP_API_GW, body, configs).then(result => result.data).catch(err => err.response.status);
    },
    postDataClaim: async function (body) {
        const data_head = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Access-Controller-Allow-Headers": "Content-Type",
            "Access-Control-Allow-Methods": "PUT, POST, PATCH, DELETE, GET"
        };

        const axiosBaseClaim = axios.create({
            baseURL: 'http://localhost:8008/v1/proxy/transfer',
            headers: data_head
        });

        const res = await axiosBaseClaim.post('', body).catch((err) => {
            return err.response.status;
        })
        return res.data;
    },
    postDataBasic: async function (body) {
        const auth_base = {
            username: process.env.REACT_APP_PHL_GW_USERNAME,
            password: process.env.REACT_APP_PHL_GW_PASSWORD,
        };
        const data_head =
        {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Access-Controller-Allow-Headers": "Content-Type",
            "Access-Control-Allow-Methods": "PUT, POST, PATCH, DELETE, GET"
        }
        const axiosBase = axios.create({
            baseURL: process.env.REACT_APP_API_GW,
            headers: data_head,
            auth: auth_base,
        });
        return await axiosBase.post('', body).then(result => result.data).catch(err => err.response.status);
    },

    postDataNoAuthen: async function (body) {
        const data_head =
        {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Access-Controller-Allow-Headers": "Content-Type",
            "Access-Control-Allow-Methods": "PUT, POST, PATCH, DELETE, GET"
        }
        const axiosBase = axios.create({
            baseURL: process.env.REACT_APP_API_LOGIN_GW,
            headers: data_head,
        });
        return await axiosBase.post('', body).then(result => result.data).catch(err => err.response.status);
    }
}